<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content>{{ data.message }}</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button (click)="onCancel()">{{ data.cancelButtonText }}</button>
  <button mat-button color="warn" (click)="onConfirm()">
    {{ data.confirmButtonText }}
  </button>
</mat-dialog-actions>
